@if (rawTextValue; as rawText) {
  <span>{{ rawText }}</span>
} @else {
  <span>{{ date | date: formatType }}</span>
}
